import { useEffect } from "react";
import RobosHeader from "@/components/RobosHeader";
import ErrorBoundary from "@/components/ErrorBoundary";
import RobotsSection from "@/components/RobotsSection";
import ValueSection from "@/components/ValueSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import VideoTestimonialsSection from "@/components/VideoTestimonialsSection";
import TeachersSection from "@/components/TeachersSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Robos = () => {
  useEffect(() => {
    // Força scroll para o topo quando a página carrega
    window.scrollTo(0, 0);
    
    // SEO Otimizado para a página /robos
    document.title = "Robôs Trader Automatizado QuantMake.AI | Day Trade e Copy Trade Premium";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Descubra os melhores robôs trader automatizado QuantMake.AI. Sistemas premium de day trade com IA, copy trade inteligente e estratégias quantitativas comprovadas para Nelogica Profit.');
    }
    
    // Adicionar meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'robôs trading automatizado, QuantMake robô trader, day trade automatizado, copy trade IA, trading quantitativo, AutoTrade premium, robô day trade Brasil, Nelogica Profit automação, BlackArrow trading, algoritmos quantitativos, sistema automático trading');
    
    // Schema markup para produtos/robôs
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Robôs Trader Automatizado QuantMake.AI",
      "description": "Sistema completo de trading automatizado com robôs inteligentes para day trade, copy trade e estratégias quantitativas comprovadas",
      "brand": {
        "@type": "Brand",
        "name": "QuantMake.AI"
      },
      "offers": {
        "@type": "AggregateOffer",
        "priceCurrency": "BRL",
        "lowPrice": "197.00",
        "highPrice": "997.00",
        "offerCount": "7",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "150",
        "bestRating": "5",
        "worstRating": "1"
      },
      "category": "Trading Automatizado",
      "audience": {
        "@type": "Audience",
        "audienceType": "Traders e Investidores"
      }
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-900">
      
      <RobosHeader />
      
      <main>
        <ErrorBoundary>
          <RobotsSection />
        </ErrorBoundary>
        <ErrorBoundary>
          <ValueSection />
        </ErrorBoundary>
        <ErrorBoundary>
          <TestimonialsSection />
        </ErrorBoundary>
        <ErrorBoundary>
          <VideoTestimonialsSection />
        </ErrorBoundary>
        <ErrorBoundary>
          <TeachersSection />
        </ErrorBoundary>
        <ErrorBoundary>
          <FAQSection />
        </ErrorBoundary>
      </main>

      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>
      <ErrorBoundary>
        <WhatsAppButton />
      </ErrorBoundary>
    </div>
  );
};

export default Robos;